<div *ngIf="this.isVisible" [style.top]="this.top + 'px'" [style.left]="this.left + 'px'"
    [style.position]="this.position" [style.zIndex]="99999"
    [ngClass]="(this.htmlContent !== null && this.htmlContent !== undefined ? 'small tooltip-comp' : 'tooltip-comp-hide')"
    [innerHTML]="this.htmlContent"
    [hidden]="(this.display === 'none' || this.htmlContent === null || this.htmlContent === undefined)">
</div>